import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import type {} from './demandReportsTypes';

import * as demandReportsApi from '@/services/demandReportsService';
import * as demandReportActions from './demandReportsActions';

export function* getDemandReportSaga({ payload }: any): SagaIterator {
	try {
		const { data } = yield call(demandReportsApi.getDemandReport, payload);
		if (data.code !== 'OK') {
			yield put(
				demandReportActions.demandReportGetDemandReportsFailure(
					data.data
				)
			);
			return;
		}
		yield put(
			demandReportActions.demandReportGetDemandReportsSuccess(
				data.message
			)
		);
	} catch (error) {
		console.log(error);
	}
}

export function* getDemandReportsSaga(): SagaIterator {
	try {
		const {
			data: { data }
		} = yield call(demandReportsApi.getDemandReports);
		if (data === 'No demand reports found for the given user') {
			yield put(
				demandReportActions.demandReportGetAllDemandReportsNoReports()
			);
		} else {
			yield put(
				demandReportActions.demandReportGetAllDemandReportsSuccess(data)
			);
		}
	} catch (error) {
		console.log(error);
	}
}
